import type React from 'react'

type MergeableRef<T> =
  React.MutableRefObject<T | null> | React.RefCallback<T> | null | undefined

export const mergeRefs =
  <T>(refs: Array<MergeableRef<T>>): React.RefCallback<T> =>
  value => {
    refs.forEach(ref => {
      const isRefTypeOfFunction = typeof ref === 'function'
      const isRefAvailable = ref != null

      if (isRefTypeOfFunction) {
        ;(ref as React.RefCallback<T>)(value)
      } else if (isRefAvailable) {
        ;(ref as React.MutableRefObject<T | null>).current = value
      }
    })
  }
